import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import { MetricType } from '@/constants/metric-type.enum';
import UnitsEnum from '@/constants/unitsEnum';
import AirTemperatureIcon from '@/comp/common/icons/AirTemperatureIcon';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { AirTemperatureSensorNodeModel } from './AirTemperatureSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';

export class AirTemperatureSensorFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.AirTemperatureSensor);
  }

  generateModel(event) {
    return new AirTemperatureSensorNodeModel(event.model);
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={50}
        height={44}
        data={[
          {
            metric: MetricType.AirTemperatureCelsius,
            unit: UnitsEnum.celsius,
            Icon: <AirTemperatureIcon />,
          },
          {
            metric: MetricType.HumidityPercentage,
            unit: UnitsEnum.percentage,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
